import { RegionType } from '@wix/shoutout-email-model-v3';
import { defaultLineHeight, defaultTextColor, defaultTextSize, } from '../../utils/defaults';
import { getTextAlign } from '../../utils/get-text-align';
import { injectMissingPropsIntoHtml } from '../../utils/inject-missing-props-into-html';
import { wrapWithElement } from '../../utils/wrap-with-element';
export const getText = ({ region, css, composerData, experiments, isRtl, manipulateHtml, }) => {
    if (region.type !== RegionType.Text) {
        throw Error('Text must be passed');
    }
    const cssClass = 'so-global-p1';
    const textStyle = css[cssClass] || {};
    const globalStyle = css['so-global-text-mix'] || {};
    const textAlign = getTextAlign(globalStyle.textAlign, isRtl ? 'right' : 'left');
    const props = {
        lineHeight: textStyle.originalLineHeight || defaultLineHeight,
        fontSize: textStyle.fontSize || defaultTextSize,
    };
    const processedHtml = manipulateHtml
        ? injectMissingPropsIntoHtml(wrapWithElement(region.data.html, 'div', cssClass), props, composerData, css, experiments, true)
        : wrapWithElement(region.data.html, 'div', cssClass);
    // TODO: here we should also return fontSize and fontStyle.
    // fontSize: textStyle.fontSize || globalStyle.fontSize
    return {
        align: textAlign,
        color: textStyle.color || defaultTextColor,
        fontFamily: textStyle.fontFamily,
        html: processedHtml,
        regionId: region.regionId,
        textTransform: textStyle.textTransform || 'none',
        type: 'text',
        repeat: region.repeat,
    };
};
//# sourceMappingURL=get-text.js.map